import { Component, EventEmitter, Input, Output, OnInit} from '@angular/core';
import { MenuItem } from 'primeng/api';

import { HisUiService, HisNotificationService } from 'hisng';

import { PatentInventor } from 'app/fs/res/patent/model/patent/patent-classes';

@Component( {
    selector: 'res-patent-internal-inventor-wizard',
    templateUrl: './patent-internal-inventor-wizard.component.html',
} )
export class PatentInternalInventorWizardComponent implements OnInit {
    @Input() patentInventor: PatentInventor;
    @Input() visibility = false;
    @Output() visibilityChange: EventEmitter<boolean> = new EventEmitter();
    @Output() savePatentInventorChange: EventEmitter<PatentInventor> = new EventEmitter();

    public currentPatentInventor: PatentInventor = new PatentInventor();
    public menuItems: MenuItem[] = [];
    public activeIndex = 0;

    constructor( private hisUiService: HisUiService,
        private notificationService: HisNotificationService ) { }

    ngOnInit() {
        if( this.patentInventor == null ) {
            this.currentPatentInventor = new PatentInventor();
            this.menuItems = [
                { label: this.hisUiService.translate('zul.Auswahl') },
                { label: this.hisUiService.translate('fs.res.patent.Patent.inventors.percentages') }
            ];
        } else {
            // assign a copy of the original object without reference
            Object.assign( this.currentPatentInventor, this.patentInventor );
        }
    }

    public submitPatentInventor() {
        this.activeIndex = 1;
    }

    public savePatentInventor() {
        this.notificationService.infoI18n( 'de.his.javang.gefunden.change' );
        if( this.patentInventor == null ) {
            this.savePatentInventorChange.emit( this.currentPatentInventor );
        } else {
            // write changes back to original object on apply
            Object.assign( this.patentInventor, this.currentPatentInventor );
        }
        this.closeDialog();
    }

    /* close dialog action */
    public closeDialog() {
        this.visibilityChange.emit(false);
    }

}
